import { jsx as n, jsxs as v } from "react/jsx-runtime";
import o, { useEffect as C } from "react";
import c, { styled as g, css as L } from "styled-components";
import { d as z, e as k, a as W, b as E } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { R as j, I as G } from "../chunks/index.cff5baaf.js";
import { R as O, B as $ } from "../chunks/index.b09c00db.js";
import { u as T } from "../chunks/useForwardRef.7bf5d172.js";
const F = c(O).withConfig({
  displayName: "ButtonIcon",
  componentId: "sc-vdybho-0"
})(["z-index:1;"]), H = c.div.withConfig({
  displayName: "BreadcrumbShowMore",
  componentId: "sc-vdybho-1"
})(["select{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;z-index:2;cursor:pointer;}"]), x = o.forwardRef(({
  options: s,
  ...p
}, u) => /* @__PURE__ */ n(H, { ref: u, ...p, children: /* @__PURE__ */ n(F, { icon: "MoreLine", size: $.LG, children: /* @__PURE__ */ n("select", { tabIndex: -1, children: s.map((d, r) => /* @__PURE__ */ n("option", { value: r, children: d }, r)) }) }) }));
x.displayName = "RangoBreadcrumbShowMore";
const q = c.div.withConfig({
  displayName: "BreadcrumbGroup",
  componentId: "sc-s4lacm-0"
})(["width:inherit;"]), I = c.span.withConfig({
  displayName: "Label",
  componentId: "sc-s4lacm-1"
})(["color:var(--text-label-color);white-space:nowrap;height:100%;"]), A = c.div.withConfig({
  displayName: "Item",
  componentId: "sc-s4lacm-2"
})(["visibility:visible;display:flex;align-items:center;&[data-show='false']{visibility:hidden;}&:last-of-type{", "{color:var(--selected-label-color);& > button{", "}}}"], I, z), D = c.div.withConfig({
  displayName: "Container",
  componentId: "sc-s4lacm-3"
})(["position:absolute;display:flex;width:fit-content;position:relative;margin:0;padding:0;height:var(--size-6x);"]), J = c(j).withConfig({
  displayName: "Separator",
  componentId: "sc-s4lacm-4"
})(["padding:0 var(--spacing-1x);"]), K = c(x).withConfig({
  displayName: "ShowMore",
  componentId: "sc-s4lacm-5"
})(["position:absolute;"]), P = o.forwardRef(({
  children: s,
  ...p
}, u) => {
  const d = T(u), r = o.useRef(null), f = o.useRef([]), m = o.useRef(null), [h, R] = o.useState(0), [S, B] = o.useState(0), [M, y] = o.useState(!1), [N, b] = o.useState([]);
  C(() => {
    const t = () => {
      var e, a;
      B((e = r.current) == null ? void 0 : e.offsetWidth), R((a = d.current) == null ? void 0 : a.offsetWidth);
    };
    return t(), window.addEventListener("load", t, !1), window.addEventListener("resize", t, !1), () => {
      window.removeEventListener("load", t), window.removeEventListener("resize", t);
    };
  }, []), C(() => _(), [h]);
  const _ = () => {
    let t = 48;
    if (h > S)
      f.current.forEach((e) => {
        e.dataset.show = "true", r.current.style.left = "0px", y(!1), b([]);
      });
    else {
      b([]);
      let e = 48, a = !1;
      f.current.reverse().forEach((i) => {
        a || h < t + i.offsetWidth ? (i.dataset.show = "false", e -= i.offsetWidth, a = !0, b((l) => [i.textContent, ...l])) : (i.dataset.show = "true", t += i.offsetWidth);
      }), r.current.style.left = `${e}px`, y(!0), setTimeout(() => {
        m.current && (m.current.style.left = `${e * -1}px`);
      }, 500);
    }
  };
  return /* @__PURE__ */ n(q, { ref: d, "data-testid": "rango-breadcrumb", "data-rango-component": "rango-breadcrumb", "data-is-rango": !0, ...p, children: /* @__PURE__ */ v(D, { ref: r, "data-testid": "rango-breadcrumb-container", role: "list", children: [
    M && /* @__PURE__ */ n(K, { ref: m, "data-testid": "rango-breadcrumb-show-more", options: N, onChange: (t) => {
      o.Children.map(s, (e, a) => {
        var i;
        if (a.toString() === t.target.value) {
          const l = e;
          (i = l == null ? void 0 : l.props) != null && i.onClick && l.props.onClick();
        }
      });
    } }),
    (() => o.Children.map(s, (t, e) => /* @__PURE__ */ v(A, { ref: (a) => f.current[e] = a, "data-index": e, role: "listitem", "data-testid": "rango-breadcrumb-childs", children: [
      e > 0 && /* @__PURE__ */ n(J, { icon: "NavigationRightLine", size: G.SM }),
      /* @__PURE__ */ n(I, { children: t })
    ] })))()
  ] }) });
});
P.displayName = "RangoBreadcrumb";
const w = g.span.withConfig({
  displayName: "Container",
  componentId: "sc-n2ypki-0"
})(['display:flex;justify-content:center;align-items:center;position:relative;z-index:0;width:100%;&::after{content:"";position:absolute;z-index:-1;top:calc(-1 * var(--spacing-1x));left:calc(-1 * var(--spacing-1x));margin:auto;width:100%;padding:var(--spacing-1x);height:100%;border-radius:var(--border-radius-sm);transition-property:background-color,opacity;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-fast-02);}']), Q = g.button.withConfig({
  displayName: "BreadcrumbItem",
  componentId: "sc-n2ypki-1"
})(["display:flex;align-items:center;background:none;border:none;height:100%;padding:var(--spacing-none);", " color:currentColor;cursor:pointer;border-radius:var(--default-border-radius);outline:none;&:hover{cursor:pointer;", "::after{", " transition-timing-function:var(--curve-productive-entrance);}}&:focus-visible{", "::after{", " outline-offset:2px;}}", ""], k, w, W, w, E, ({
  as: s
}) => s === "a" && L`
      display: inline-flex;
    `), U = g.span.withConfig({
  displayName: "MotionLayer",
  componentId: "sc-n2ypki-2"
})(["position:absolute;z-index:-1;top:calc(-1 * var(--spacing-1x));left:calc(-1 * var(--spacing-1x));padding:var(--spacing-1x);width:100%;height:100%;"]), V = g.span.withConfig({
  displayName: "MotionLayerClick",
  componentId: "sc-n2ypki-3"
})(["width:calc(100% + var(--spacing-2x));height:calc(100% + var(--spacing-2x));display:inline-flex;position:relative;justify-content:center;align-items:center;margin:calc(-1 * var(--spacing-1x));border-radius:var(--border-radius-sm);"]), X = o.forwardRef(({
  actionItem: s = "button",
  selected: p,
  children: u,
  onClick: d,
  ...r
}, f) => /* @__PURE__ */ n(Q, { ref: f, ...r, as: s, selected: p, onClick: (h) => {
  d && d(h);
}, children: /* @__PURE__ */ v(w, { children: [
  /* @__PURE__ */ n(U, { children: /* @__PURE__ */ n(V, {}) }),
  u
] }) }));
X.displayName = "RangoBreadcrumbItem";
export {
  P as RangoBreadcrumb,
  X as RangoBreadcrumbItem
};
